// extracted by mini-css-extract-plugin
export var container = "lcContactBlock-module--container--c5b01";
export var description = "lcContactBlock-module--description--b7eac";
export var link = "lcContactBlock-module--link--e3da7";
export var text = "lcContactBlock-module--text--89072";
export var title = "lcContactBlock-module--title--69b8b";